import { React, useState } from "react";
import {
  CircleChart,
  LineDashedChart,
  BasicColumnChart,
  BasicColumnChartForJob,
  CircleChartManager,
  LineDashedChartManager,
  BasicColumnChartForJobAiAnalysisManager,
} from "../components/ContainerChart";
import StatCard from "../components/common/StateCard";

import { IoIosArrowForward } from "react-icons/io";
import { IoIosArrowBack } from "react-icons/io";

// import ChartMiniGreen from "../../../assets/ChartMiniGreen.svg";
// import ChartMiniRed from "../../../assets/ChartMiniRed.png";
// import ChartMiniOrange from "../../../assets/ChartMiniOrange.png";

const ManagerAiAnalysis = () => {
  const [pipelineData, setPipelineData] = useState([
    { stage: "Applied", count: 1286, percentage: 85 },
    { stage: "Shortlisted", count: 864, percentage: 65 },
    { stage: "Interviews", count: 624, percentage: 45 },
    { stage: "Offer Sent", count: 246, percentage: 25 },
    { stage: "Hired", count: 124, percentage: 15 },
  ]);
  const [stats, setStats] = useState({
    activeJobs: { count: 2420, change: 40 },
    shortlisted: { count: 80, change: -10 },
    timeToHire: { count: 70, change: 20 },
  });
  return (
    <div>
      <div className="flex w-full justify-start items-start flex-row ">
        <div className=" flex-1 flex-col gap-6 pt-2 w-full">
          <div className="flex self-stretch justify-start items-start flex-col gap-8 pt-[32px] pb-[48px] ">
            <div className="flex self-stretch justify-start items-start flex-col gap-6">
              <div className="flex self-stretch justify-start items-start flex-col gap-5 px-[32px]">
                <div className="flex self-stretch justify-start items-start flex-col gap-5">
                  <div className="flex flex-wrap self-stretch justify-start items-start flex-row gap-y-5 gap-x-4">
                    <div className="min-w-[320px] flex flex-1 justify-start items-start flex-col gap-1">
                      <p className="self-stretch text-[#181D27] text-2xl  font-semibold">
                        AI Analysis
                      </p>
                      <p className="self-stretch text-[#535862] ">
                        Here is a complete AI overview of your system.
                      </p>
                    </div>
                    <div className="flex justify-start items-center flex-row gap-3">
                      <div className="flex justify-center items-center flex-row gap-1 py-2.5 px-3.5 bg-[#FFFFFF] border-solid border-[#D5D7DA] border rounded-lg shadow-[_0px_1px_2px_0px_rgba(10,13,18,0.05),inset_0px_-2px_0px_0px_rgba(10,13,18,0.05),inset_0px_0px_0px_1px_rgba(10,13,18,0.18)]">
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M6.66663 13.3333L9.99996 10M9.99996 10L13.3333 13.3333M9.99996 10V17.5M16.6666 13.9524C17.6845 13.1117 18.3333 11.8399 18.3333 10.4167C18.3333 7.88536 16.2813 5.83333 13.75 5.83333C13.5679 5.83333 13.3975 5.73833 13.3051 5.58145C12.2183 3.73736 10.212 2.5 7.91663 2.5C4.46485 2.5 1.66663 5.29822 1.66663 8.75C1.66663 10.4718 2.36283 12.0309 3.48908 13.1613"
                            stroke="#414651"
                            strokeWidth="1.66667"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                        <div className="flex justify-center items-center flex-row px-0.5">
                          <span className="text-[#414651] text-sm  font-semibold">
                            Import
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="flex self-stretch justify-start items-start flex-col gap-6">
              <div className="flex self-stretch justify-start items-start flex-col gap-6 px-[32px]">
                <div className="w-full grid grid-cols-1 lg:grid-cols-3 md:grid-cols-2 gap-6 mb-6">
                  <StatCard
                    title="Total Job Openings"
                    count={stats.activeJobs.count}
                    change={stats.activeJobs.change}
                    trend="M0 45L20 35L40 40L60 30L80 35L100 25L120 30L140 20L160 25L180 15L200 20"
                  />
                  <StatCard
                    title="Candidate Engagement Score "
                    count={stats.shortlisted.count}
                    change={stats.shortlisted.change}
                    trend="M0 20L20 25L40 20L60 25L80 30L100 25L120 30L140 35L160 40L180 45L200 50"
                    suffix="%"
                  />
                  <StatCard
                    title="Offer Acceptance Rate "
                    count={stats.timeToHire.count}
                    change={stats.timeToHire.change}
                    trend="M0 30L20 25L40 35L60 30L80 40L100 35L120 45L140 40L160 50L180 45L200 55"
                    suffix="%"
                  />
                </div>
              </div>
            </div>
            <div className="px-[32px] w-full">
              <div className="grid xl:grid-cols-2 gap-6">
                <div
                  className="flex w-full justify-start items-start flex-col bg-[#FDFDFD] border-solid border-[#E9EAEB] border rounded-xl shadow-[_0px_1px_2px_0px_rgba(10,13,18,0.05)] "
                  // style={{ width: "451px" }}
                >
                  <div className="flex self-stretch justify-start items-start flex-col gap-0.5">
                    <div className="flex self-stretch justify-start items-center flex-row gap-4 pt-3 pb-2 px-[20px]">
                      <p className="flex-1 text-[#181D27] text-sm  font-semibold">
                        Active now
                      </p>
                    </div>
                    <div className=" h-full w-full justify-start items-start flex-col bg-[#FFFFFF] border-solid border-[#E9EAEB] border rounded-xl shadow-[_0px_1px_2px_0px_rgba(10,13,18,0.05)]">
                      <CircleChartManager />
                    </div>
                  </div>
                </div>
                <div className="bg-white  rounded-xl border border-gray-200">
                  <div className="bg-gray-50 py-3 px-5">
                    <h3 className="text-sm font-semibold text-gray-900">
                      Hiring Pipeline Breakdown
                    </h3>
                  </div>

                  <div className=" h-96 grid grid-cols-5 gap-3 py-3 px-5 border-t rounded-t-md border-gray-200">
                    {pipelineData.map((stage, index) => (
                      <div
                        key={stage.stage}
                        className="border flex flex-col gap-4 justify-between rounded-md border-gray-200 p-2"
                      >
                        <div className=" flex flex-col gap-2 text-sm mb-1">
                          <p className="text-gray-600 text-md font-semibold">
                            Step {index + 1}
                          </p>
                          <h3 className="text-gray-900 xl:text-sm text-xs font-semibold">
                            {stage.stage}
                          </h3>
                        </div>
                        <div className=" relative h-40 rotate-180  bg-transparent overflow-hidden">
                          <div
                            className={`h-full ${
                              index === 0
                                ? "bg-[#19BFB7]"
                                : index === 1
                                ? "bg-[#17ACA5]"
                                : index === 2
                                ? "bg-[#149992]"
                                : index === 3
                                ? "bg-[#138F89]"
                                : index === 4
                                ? "bg-[#0F736E]"
                                : ""
                            } rounded-lg`}
                            style={{ height: `${stage.percentage}%` }}
                          />
                          <span className="font-medium absolute top-1 -translate-x-1/2 left-1/2 rotate-180 text-white">
                            {stage.count.toLocaleString()}
                          </span>
                        </div>

                        <div className="text-xs flex gap-3 flex-col text-gray-500 mt-1">
                          <h4>Dropout ratio</h4>
                          <div className="flex items-center gap-1 text-green-600 font-semibold">
                            <span className="text-gray-900">0%</span>
                            <span>↑ 8.6%</span>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
            <div className="flex self-stretch justify-start items-start flex-row gap-6">
              <div className="flex flex-1 justify-start items-start flex-row gap-6 px-[32px]">
                <div className="flex flex-1 justify-start items-start flex-col bg-[#FDFDFD] border-solid border-[#E9EAEB] border rounded-xl shadow-[_0px_1px_2px_0px_rgba(10,13,18,0.05)]">
                  <div className="flex self-stretch justify-start items-start flex-col gap-0.5">
                    <div className="flex self-stretch justify-start items-center flex-row gap-4 pt-3 pb-2 px-[20px]">
                      <p className="flex-1 text-[#181D27] text-sm  font-semibold">
                        Avg. Time to Hire
                      </p>
                    </div>
                    <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF] border-solid border-[#E9EAEB] border rounded-xl shadow-[_0px_1px_2px_0px_rgba(10,13,18,0.05)]">
                      <div className="flex self-stretch justify-start items-start flex-col gap-5 p-[20px] rounded-xl">
                        <div className="flex self-stretch justify-start items-start flex-row gap-4">
                          <div className="flex flex-1 justify-start items-start flex-col gap-2">
                            <div className="flex self-stretch justify-start items-center flex-row gap-3">
                              <span className="text-[#181D27] text-3xl  font-semibold">
                                2 Weeks
                              </span>
                              <div className="flex justify-start items-center flex-row gap-1 py-0.5 pr-2 pl-1.5 bg-[#FFFFFF] border-solid border-[#D5D7DA] border rounded-md shadow-[_0px_1px_2px_0px_rgba(10,13,18,0.05)]">
                                <svg
                                  width="12"
                                  height="12"
                                  viewBox="0 0 12 12"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M3.5 8.5L8.5 3.5M8.5 3.5H3.5M8.5 3.5V8.5"
                                    stroke="#17B26A"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                </svg>
                                <span className="text-[#414651] text-sm  text-center font-medium">
                                  2.4%
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className="flex justify-start items-start flex-row gap-3">
                            <div className="flex justify-start items-center flex-row gap-0.5 bg-[#FAFAFA] border-solid border-[#E9EAEB] border rounded-lg">
                              <div className="flex justify-center items-center flex-row gap-2 py-2 px-3 bg-[#FFFFFF] border-solid border-[#D5D7DA] border rounded-lg shadow-[_0px_1px_2px_0px_rgba(10,13,18,0.05)] h-[36px]">
                                <span className="text-[#414651] text-sm  font-semibold">
                                  12 months
                                </span>
                              </div>
                              <div className="flex justify-center items-center flex-row gap-2 py-2 px-3 rounded-lg h-[36px]">
                                <span className="text-[#717680] text-sm  font-semibold">
                                  30 days
                                </span>
                              </div>
                              <div className="flex justify-center items-center flex-row gap-2 py-2 px-3 rounded-lg h-[36px]">
                                <span className="text-[#717680] text-sm  font-semibold">
                                  7 days
                                </span>
                              </div>
                              <div className="flex justify-center items-center flex-row gap-2 py-2 px-3 rounded-lg h-[36px]">
                                <span className="text-[#717680] text-sm  font-semibold">
                                  24 hours
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="w-full px-5">
                        <LineDashedChartManager />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="w-full gap-6">
              <div className="grid w-full lg:grid-cols-2 gap-6 px-[32px]">
                <div className=" w-full bg-[#FDFDFD] border-solid border-[#E9EAEB] border rounded-xl shadow-[_0px_1px_2px_0px_rgba(10,13,18,0.05)]">
                  <div className=" justify-start items-start flex-col gap-0.5">
                    <div className="flex self-stretch justify-start items-center flex-row gap-4 pt-3 pb-2 px-[20px]">
                      <p className="flex-1 text-[#181D27] text-sm  font-semibold">
                        Candidate Quality
                      </p>
                    </div>
                    <div className=" bg-[#FFFFFF] border-solid border-[#E9EAEB] border rounded-xl shadow-[_0px_1px_2px_0px_rgba(10,13,18,0.05)]">
                      <div className="w-full px-7">
                        <BasicColumnChart />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="flex flex-1 justify-start items-start flex-col bg-[#FDFDFD] border-solid border-[#E9EAEB] border rounded-xl shadow-[_0px_1px_2px_0px_rgba(10,13,18,0.05)]">
                  <div className="flex self-stretch justify-start items-start flex-col gap-0.5">
                    <div className="flex self-stretch justify-start items-center flex-row gap-4 pt-3 pb-2 px-[20px]">
                      <p className="flex-1 text-[#181D27] text-sm  font-semibold">
                        Job Listing Performance
                      </p>
                    </div>
                    <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF] border-solid border-[#E9EAEB] border rounded-xl shadow-[_0px_1px_2px_0px_rgba(10,13,18,0.05)]">
                      <div className="w-full px-7">
                        <BasicColumnChartForJobAiAnalysisManager />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ManagerAiAnalysis;